module.exports = __webpack_public_path__ + "static/media/Takeoff.bcc89325.png";